/**
 * The score table as the Worker sends it. Mirrors `CompetitionScorecard` in
 * packages/validation/src/schemas/competitionScorecard.ts — kept here as plain
 * types because the public site does not depend on the validation package.
 */

export type ScorecardMark = 'top' | 'flash'

export interface ScorecardRound {
  id: string
  name: string
  sort_order: number
  starts_at: string
  ends_at: string
  state: 'upcoming' | 'in_progress' | 'ended'
}

export interface ScorecardRoute {
  routeId: string
  label: string
  roundId: string | null
  board: 'boulder' | 'lead'
  color: string | null
  tops: number
  topPoints: number
  flashPoints: number
}

export interface ScorecardClimber {
  userId: string
  displayName: string
  fullName?: string
  nickname?: string | null
  avatarExt?: string | null
  avatarUpdatedAt?: string | null
  rank: number
  totalScore: number
  routesClimbed: number
  flashesCount: number
  isPrivate?: boolean
  marks: Record<string, ScorecardMark>
}

export interface ScorecardData {
  scoringType: string
  discipline: string
  categoryId: string
  rounds: ScorecardRound[]
  routes: ScorecardRoute[]
  climbers: ScorecardClimber[]
}

/** What a mark is worth on a route. The Worker has already done the maths. */
export function markPoints(route: ScorecardRoute, mark: ScorecardMark | undefined): number {
  if (!mark) return 0
  return mark === 'flash' ? route.flashPoints : route.topPoints
}

/** A climber's points over some routes, rounded the way the board rounds. */
export function pointsOver(routes: ScorecardRoute[], climber: ScorecardClimber): number {
  let total = 0
  for (const route of routes) total += markPoints(route, climber.marks[route.routeId])
  return Math.round(total * 100) / 100
}
